import React, { useEffect, useState, useCallback } from "react";
import {
  StyledHeader,
  MobileMenu,
  MobileMenuOverlay,
  BurgerButton,
} from "./HeaderStyled";
import Logo from "../../../../assets/images/saharaText.png";
import { headerItems } from "./constant";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import ThemeToggle from "../../../../components/Common/ThemeToggle/ThemeToggle";

const menuIcons: Record<string, JSX.Element> = {
  Home: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  ),
  "About Us": (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
  ),
  Work: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  ),
  Service: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
    </svg>
  ),
  Contact: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  ),
};

const Header = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const menuRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close menu on outside click
  const handleClickOutside = useCallback((event: MouseEvent) => {
    if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      setOpen(false);
    }
  }, []);

  useEffect(() => {
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "hidden";
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "";
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "";
    };
  }, [open, handleClickOutside]);

  const handleMenuItemClick = () => {
    setOpen(false);
  };

  return (
    <>
      <StyledHeader className={scrolled ? "scrolled" : ""}>
        <div className="headerContainer">
          <img
            src={Logo}
            alt="Sahara Computers Logo"
            className="imageLogo"
            onClick={() => navigate("/")}
          />
          <div className="headerItems">
            <ul>
              {headerItems
                .filter((item) => item.name !== "Contact")
                .map((item) => (
                  <li key={item.id}>
                    <Link to={item.path}>{item.name}</Link>
                  </li>
                ))}
            </ul>
            <Link to="/products" className="ctaButtonSecondary">
              Our Products
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <rect x="3" y="3" width="7" height="7" />
                <rect x="14" y="3" width="7" height="7" />
                <rect x="14" y="14" width="7" height="7" />
                <rect x="3" y="14" width="7" height="7" />
              </svg>
            </Link>
            <Link to="/#contactUs" className="ctaButton">
              Get in Touch
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </Link>
            <div className="themeToggleWrapper">
              <ThemeToggle />
            </div>
          </div>
        </div>
        <div className="mobileHeader">
          <ThemeToggle />
          <BurgerButton open={open} onClick={() => setOpen(!open)}>
            <span />
            <span />
            <span />
          </BurgerButton>
        </div>
      </StyledHeader>

      {/* Mobile Menu */}
      <MobileMenuOverlay open={open} onClick={() => setOpen(false)} />
      <MobileMenu open={open} ref={menuRef}>
        <div className="menuHeader">
          <img src={Logo} alt="Sahara Computers Logo" className="menuLogo" />
          <button className="closeBtn" onClick={() => setOpen(false)}>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <div className="menuItems">
          <ul>
            {headerItems.map((item) => (
              <li key={item.id}>
                <Link to={item.path} onClick={handleMenuItemClick}>
                  <span className="menuIcon">{menuIcons[item.name]}</span>
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="menuFooter">
          <Link
            to="/products"
            className="menuCtaSecondary"
            onClick={handleMenuItemClick}
          >
            Our Products
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <rect x="3" y="3" width="7" height="7" />
              <rect x="14" y="3" width="7" height="7" />
              <rect x="14" y="14" width="7" height="7" />
              <rect x="3" y="14" width="7" height="7" />
            </svg>
          </Link>
          <Link
            to="/#contactUs"
            className="menuCta"
            onClick={handleMenuItemClick}
          >
            Get in Touch
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </Link>
          <div className="themeRow">
            <span>Theme</span>
            <ThemeToggle />
          </div>
        </div>
      </MobileMenu>
    </>
  );
};

export default Header;
